import { FC } from 'react'

import { AccessoriesCarousel } from '@/widgets/AccessoriesCarousel/AccessoriesCarousel'

import { useGetProductAccessoriesQuery } from '@/entities/product'

import { ItemLoader } from '@/shared/ui/Skeletons/variants/ItemLoader/ItemLoader'

import cl from './accessories-tab.module.scss'

type AccessoriesTabProps = {
	productId: number
}

const SKELETONS_COUNT = 15

/**
 * Accessories tab on the products page.
 * Fetches its own data on mount — the tab mounts only when opened, so this stays off the
 * initial-load path (no accessories request until the user views the tab).
 */
export const AccessoriesTab: FC<AccessoriesTabProps> = ({ productId }) => {
	const { data: accessoires, isLoading } = useGetProductAccessoriesQuery(productId)

	if (isLoading || !accessoires) {
		return (
			<section className={cl.skeletons}>
				{Array.from({ length: SKELETONS_COUNT }, (_, index) => (
					<div className={cl.skeleton} key={index}>
						<ItemLoader width={288} />
					</div>
				))}
			</section>
		)
	}

	return (
		<section>
			<AccessoriesCarousel
				catalogItemType="accessories"
				items={Object.values(accessoires)}
				relatedId={productId}
				grid
				tabButtonType="button"
				location="Product Accessories"
			/>
		</section>
	)
}
